import {
  LIMITE_TETO_REDUTOR_2026,
  VALOR_FIXO_REDUTOR_2026,
  FATOR_REDUTOR_2026,
  VALOR_FIXO_REDUTOR_ISENTO_2026,
  LIMITE_ISENCAO_2026,
} from './constants';
import { arredondar } from '../util/money';

export default class CalculadoraIrrf {
  constructor(faixasIrrf = []) {
    this.faixasIrrf = faixasIrrf.map((faixa, index) => ({ ...faixa, index }));
  }

  calcularIrrf(baseIrrf, salarioBrutoTributavel = null) {
    if (this.faixasIrrf.length === 0) {
      return 0;
    }

    const { calculo: aliquota = 0, subtracao = 0 } =
      this.getFaixaDaBaseIrrf(baseIrrf) || {};

    const irrfBruto = baseIrrf * aliquota - subtracao;
    const redutorAdicional = CalculadoraIrrf.getRedutorAdicional(
      salarioBrutoTributavel
    );

    return arredondar(Math.max(0, irrfBruto - redutorAdicional));
  }

  static getRedutorAdicional(salarioBruto) {
    if (salarioBruto > LIMITE_TETO_REDUTOR_2026) {
      return 0;
    }

    if (salarioBruto <= LIMITE_ISENCAO_2026) {
      return VALOR_FIXO_REDUTOR_ISENTO_2026;
    }

    return VALOR_FIXO_REDUTOR_2026 - FATOR_REDUTOR_2026 * salarioBruto;
  }

  calcularIrrfComplementar(baseIrrf, irrf, salarioBrutoTributavel = null) {
    if (this.faixasIrrf.length === 0) {
      return 0;
    }

    const { calculo: aliquota = 0, subtracao = 0 } =
      this.getFaixaDaBaseIrrf(baseIrrf) || {};

    const irrfTotalBruto = baseIrrf * aliquota - subtracao - irrf;
    const redutor = CalculadoraIrrf.getRedutorAdicional(salarioBrutoTributavel);

    return arredondar(Math.max(0, irrfTotalBruto - redutor));
  }

  getFaixaDaBaseIrrf(baseIrrf) {
    let valorFaixaAnterior = 0;
    let faixaIrrf = null;

    this.faixasIrrf.forEach((faixa) => {
      const valorFaixaAtual = faixa.valor || 0;
      if (baseIrrf >= valorFaixaAnterior && baseIrrf <= valorFaixaAtual) {
        faixaIrrf = faixa;
      }
      valorFaixaAnterior = valorFaixaAtual;
    });

    return faixaIrrf;
  }
}
